import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { littersData as staticLitters } from '../data/litters';
import { fetchLitters } from '../lib/api';
import { useSupabaseData } from '../lib/useSupabaseData';
import { img } from '../lib/img';
import { Reveal, RevealHeading } from '../components/Reveal';

const LitterCard = ({ id, letter, date, presentationImage }) => {
  return (
    <Reveal as="div" className="mb-12" amount={0.15}>
      <Link to={`/mioty/${id}`} className="block group">
        <div className="text-center mb-4">
          <h2 className="text-3xl md:text-4xl text-brand-accent group-hover:text-brand-accent/80 transition-colors">{`Miot ${letter}`}</h2>
          <p className="text-brand-text-light/70 mt-1">{date}</p>
        </div>
        <motion.div
          layoutId={`litter-image-${id}`}
          className="w-full bg-brand-bg-side shadow-lg transition-transform duration-500 group-hover:scale-[1.03] overflow-hidden rounded-lg"
        >
          <img src={img(presentationImage, { w: 800 })} alt={`Miot ${letter}`} loading="lazy" decoding="async" className="w-full h-auto object-contain" />
        </motion.div>
      </Link>
    </Reveal>
  );
};

const LittersPage = () => {
  const { t } = useTranslation();
  const { data: littersData } = useSupabaseData(fetchLitters, staticLitters, 'litters');

  // Sort litters by date, newest first
  const sortedLitters = [...littersData].sort((a, b) => {
    // Custom parser because date format is tricky for new Date()
    const [dayA, monthA, yearA] = (a.date || '').split(' ');
    const [dayB, monthB, yearB] = (b.date || '').split(' ');
    const months = { 'stycznia': 0, 'luty': 1, 'marca': 2, 'kwietnia': 3, 'maja': 4, 'czerwca': 5, 'lipca': 6, 'sierpnia': 7, 'września': 8, 'października': 9, 'listopada': 10, 'grudnia': 11 };
    const dateA = new Date(yearA, months[monthA], dayA);
    const dateB = new Date(yearB, months[monthB], dayB);
    return dateB - dateA;
  });

  return (
    <div className="animate-fadeIn">
      <section className="my-12 md:my-20 text-center">
        <RevealHeading as="h1" text={t('litters.title')} className="text-4xl md:text-5xl text-brand-accent" />
        <Reveal as="p" delay={0.18} className="mt-4 text-lg md:text-xl text-brand-text-light/80 max-w-2xl mx-auto">
          {t('litters.subtitle')}
        </Reveal>
      </section>

      <div className="max-w-xl mx-auto">
        {sortedLitters.map(litter => <LitterCard key={litter.id} {...litter} />)}
      </div>
    </div>
  );
};

export default LittersPage; 